import { render, staticRenderFns } from "./CategoryField.vue?vue&type=template&id=37417ab8&scoped=true"
import script from "./CategoryField.vue?vue&type=script&lang=js"
export * from "./CategoryField.vue?vue&type=script&lang=js"
import style0 from "./CategoryField.vue?vue&type=style&index=0&id=37417ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37417ab8",
  null
  
)

export default component.exports